<div class="row m-0" style="margin-top: 70px !important;">
    @if (latestNews && latestNews.length) {
        <div id="carouselText" class="col-12 p-0 py-3">
            <ngb-carousel id="infoCustomCarousel" [interval]="5000" [pauseOnHover]="false" [wrap]="true" [showNavigationArrows]="showNavigationArrows" [showNavigationIndicators]="showNavigationIndicators">
                @for (news of latestNews; track news.title) {
                    <ng-template ngbSlide>
                        <h6 class="d-flex justify-content-center align-items-center px-4" [innerHTML]="news.title | NewSafeHTML"></h6>
                    </ng-template>
                }
            </ngb-carousel>
        </div>
    }
</div>